import InputDropdown from 'components/form/inputDropdown'
import InputText from 'components/form/inputText'
import { getOptionsDropDown, handleSetValueInput } from 'lib/FormUtils'
import moment from 'moment'
import React, { Component, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import {
	IActivationMissingInputsProps,
	IActivationMissingInputsState
} from './ActivationMissingInputsType'

class ActivationMissingInputs extends Component<
	IActivationMissingInputsProps,
	IActivationMissingInputsState
> {
	constructor(props: IActivationMissingInputsProps) {
		super(props)
		this.state = {}
	}

	/**
	 * to set max date
	 * @param date
	 */
	handleOnBlurInitDate = (date: Date) => {
		const { setFieldTouched, setFieldValue, values } = this.props
		const formikProps = { setFieldTouched, setFieldValue }
		const customDate = moment(date)
		const endDate = moment(values.fec_fin)

		if (customDate.isValid() && !endDate.isValid()) {
			handleSetValueInput(date, 'fec_fin', formikProps, 'date')
		}
	}

	render() {
		const {
			fields,
			filterBranches,
			t,
			setFieldTouched,
			setFieldValue,
			handleBlur,
			values
		} = this.props

		const formikProps = { setFieldTouched, setFieldValue }

		const dateFrom = {
			inputFormCol: { sm: 6 },
			fields,
			label: 'Fecha',
			inputId: 'fec_ini',
			name: 'fec_ini',
			placeholder: t('global.from'),
			colLabel: 'col-sm-4',
			colInput: 'col-sm-8',
			disable: false,
			onBlur: this.handleOnBlurInitDate,
			value: values.fec_ini,
			maxDate: values.fec_fin,
			autoComplete: 'off',
			onChange: (date: string) =>
				handleSetValueInput(date || '', 'fec_ini', formikProps, 'date')
		}

		const dateUntil = {
			inputFormCol: { sm: 6 },
			fields,
			label: 'Fecha',
			inputId: 'fec_fin',
			name: 'fec_fin',
			placeholder: t('global.until'),
			colLabel: 'col-sm-4',
			colInput: 'col-sm-8',
			disable: false,
			styleLabel: { textAlign: 'right' },
			onBlur: () => {},
			value: values.fec_fin,
			minDate: values.fec_ini,
			autoComplete: 'off',
			onChange: (date: Date) =>
				handleSetValueInput(date || '', 'fec_fin', formikProps, 'date')
		}

		const branchesProps = {
			inputFormCol: { sm: 12 },
			fields,
			label: t('search_voucher.type_voucher'),
			inputId: 'Sucursal',
			name: 'Sucursal',
			placeholder: '',
			colLabel: 'col-sm-2',
			colInput: 'col-sm-10',
			onBlur: handleBlur,
			value: values.Sucursal,
			options: getOptionsDropDown(filterBranches),
			noInitialExecute: true,
			onChange: (data: any) =>
				handleSetValueInput(data, 'Sucursal', formikProps)
		}

		return (
			<Fragment>
				<InputText {...dateFrom} />
				<InputText {...dateUntil} />
				<InputDropdown {...branchesProps} />
			</Fragment>
		)
	}
}

const mapStateToProps = ({ searchVoucher, tableCalls }: any) => {
	const { filterBranches, sortDirOptions } = searchVoucher
	const { sortDirCbtOptions, optionsFilterAffected } = tableCalls
	return {
		filterBranches,
		sortDirCbtOptions,
		sortDirOptions,
		optionsFilterAffected
	}
}

const mapDispatchToProps = {}

const connectForm = connect(
	mapStateToProps,
	mapDispatchToProps
)(ActivationMissingInputs)

export default withTranslation()(connectForm)
